<script setup lang="ts">
import { watchEffect, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    showClose: {
        type: Boolean,
        default: false
    },
    showIcon: {
        type: Boolean,
        default: true
    },
    title: {
        type: String,
        required: false,
        default: "title"
    },
    message: {
        type: String,
        required: false,
        default: "message"
    },
    persistent: {
        type: Boolean,
        default: false
    },
    width: {
        type: String,
        default: "350px"
    }
});

const isVisible = ref(props.modelValue);

const emit = defineEmits(['update:modelValue']);

watchEffect(() => {
    isVisible.value = props.modelValue;
});

watch(isVisible, (newValue) => {
    emit('update:modelValue', newValue);
});

function closeDialog() {
    isVisible.value = false;  // 关闭对话框
}
</script>

<template>
    <v-dialog v-model="isVisible" :persistent="persistent" :width="width">
        <div class="relative">
            <div v-if="showClose" class="window-close flex text-[#FFFFFF33] absolute right-2 top-2 z-50">
                <v-icon icon="mdi-window-close" class="text-[base] md:text-xl lg:text-[28px] cursor-pointer" @click="isVisible = false"></v-icon>
            </div>
            <slot name="content">
                <div class="box bg-neutral-800 flex flex-col items-center justify-center rounded-2xl p-5 md:w-[400px]">
                    <div class="icon my-2" v-if="showIcon">
                        <v-icon icon="mdi-alert-circle" color="#F06906" class="text-[40px]"></v-icon>
                    </div>
                    <div class="title font-semibold text-lg my-3">{{ title }}</div>
                    <div class="message text-sm text-center">{{ message }}</div>
                    <div class="actions w-full flex items-center justify-center mt-6">
                        <slot name="actions">
                            <v-btn class="rounded-full flex-1 mx-1 font-semibold text-black bg-[#F06906] !h-10" @click="closeDialog">Got it</v-btn>
                        </slot>
                    </div>
                </div>
            </slot>
        </div>
    </v-dialog>
</template>
<style lang="scss" scoped>
:deep(.v-btn--variant-elevated) {
    box-shadow: none;
}
:deep(.v-dialog > .v-overlay__content) {
    max-width: 95vw !important;
}
</style>